import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=f1e4ce3e&scoped=true&"
import script from "./PermissionModal.vue?vue&type=script&lang=js&"
export * from "./PermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=f1e4ce3e&prod&lang=css&"
import style1 from "./PermissionModal.vue?vue&type=style&index=1&id=f1e4ce3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e4ce3e",
  null
  
)

export default component.exports